import Vue from 'vue'
import VueVisible from 'vue-visible'

Vue.use(VueVisible)



// WEBPACK FOOTER //
// ./src/plugins/vue-visible.js